/* eslint-disable max-len */
/* eslint-disable no-await-in-loop */
import React from 'react';
import Molten from '@leverege/molten';
import { Dialog, Toast } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import { LoadingView } from '@leverege/molten/views';
import S from './RemoveFromConsumerNetworkDialog.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default class RemoveFromConsumerNetworkDialog extends React.Component {
  onOkay = async () => {
    const {
      vehicles = [],
      onClose
    } = this.props;
    const closeLoading = LoadingView.showDialog('Removing vehicle from consumer network');
    try {
      const systemId = Molten.getConfig('api/systemId');
      await GlobalState.dispatch(async (dispatch, getState, {
        api
      }) => {
        for (let i = 0; i < vehicles.length; i++) {
          const vehicle = vehicles[i];
          await api.interface(systemId, 'vehicle').obj(vehicle.id).srv('recovr').post('removeFromCustomerNetwork');
        }
      });
      Toast.success('Vehicle removed from consumer network successfully');
    } catch (err) {
      Toast.error('Could not remove vehicle from consumer network');
      console.log('Could not remove vehicle from consumer network', err);
    }
    closeLoading();
    onClose();
  };
  onCancel = () => {
    const {
      onClose
    } = this.props;
    onClose();
  };
  render() {
    const {
      show,
      onClose
    } = this.props;
    return /*#__PURE__*/_jsx(Dialog.Question, {
      show: show,
      onClose: onClose,
      icon: "https://storage.googleapis.com/molten-ui-assets/remove-action.png",
      title: "Release VIN for Dealers",
      okay: "Proceed",
      okayVariant: "primaryDestructive",
      cancelVariant: "secondary",
      onOkay: this.onOkay,
      onCancel: this.onCancel,
      children: /*#__PURE__*/_jsxs("div", {
        className: S.body,
        children: [/*#__PURE__*/_jsx("div", {
          children: "This action will allow dealers to create this VIN in their vehicle inventory."
        }), /*#__PURE__*/_jsx("div", {
          children: "Warning: This will remove the vehicle from the consumer network, unpair the locator, and disconnect any car owners from accessing this vehicle and locator within the RecovR Mobile App."
        })]
      })
    });
  }
}